import type { JobStatus } from "./types";

export function money(cents: number | null | undefined, currency = "USD") {
  if (cents == null) return "—";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function relTime(unixSec: number | null | undefined) {
  if (!unixSec) return "—";
  const diff = unixSec * 1000 - Date.now();
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ["year", 31536000000],
    ["month", 2592000000],
    ["week", 604800000],
    ["day", 86400000],
    ["hour", 3600000],
    ["minute", 60000],
    ["second", 1000],
  ];
  for (const [unit, ms] of units) {
    if (abs >= ms || unit === "second") {
      return rtf.format(Math.round(diff / ms), unit);
    }
  }
  return "now";
}

export function absDate(unixSec: number | null | undefined) {
  if (!unixSec) return "—";
  return new Date(unixSec * 1000).toLocaleDateString(undefined, {
    year: "numeric", month: "short", day: "numeric",
  });
}

export const STATUS_LABEL: Record<JobStatus, string> = {
  submitted: "Submitted",
  pending_quote: "Pending quote",
  awaiting_deposit: "Awaiting deposit",
  queued: "In queue",
  in_progress: "In progress",
  awaiting_feedback: "Awaiting your feedback",
  final_payment_due: "Final payment due",
  delivered: "Delivered",
  complete: "Complete",
  rejected: "Rejected",
  cancelled: "Cancelled",
};

export const STATUS_TONE: Record<JobStatus, string> = {
  submitted: "bg-neutral-200 text-neutral-900 dark:bg-neutral-800 dark:text-neutral-100",
  pending_quote: "bg-amber-100 text-amber-900 dark:bg-amber-950/60 dark:text-amber-200",
  awaiting_deposit: "bg-amber-100 text-amber-900 dark:bg-amber-950/60 dark:text-amber-200",
  queued: "bg-sky-100 text-sky-900 dark:bg-sky-950/60 dark:text-sky-200",
  in_progress: "bg-violet-100 text-violet-900 dark:bg-violet-950/60 dark:text-violet-200",
  awaiting_feedback: "bg-fuchsia-100 text-fuchsia-900 dark:bg-fuchsia-950/60 dark:text-fuchsia-200",
  final_payment_due: "bg-amber-100 text-amber-900 dark:bg-amber-950/60 dark:text-amber-200",
  delivered: "bg-emerald-100 text-emerald-900 dark:bg-emerald-950/60 dark:text-emerald-200",
  complete: "bg-emerald-100 text-emerald-900 dark:bg-emerald-950/60 dark:text-emerald-200",
  rejected: "bg-rose-100 text-rose-900 dark:bg-rose-950/60 dark:text-rose-200",
  cancelled: "bg-neutral-200 text-neutral-800 dark:bg-neutral-900 dark:text-neutral-400",
};

export const STATUS_ORDER: JobStatus[] = [
  "submitted",
  "pending_quote",
  "awaiting_deposit",
  "queued",
  "in_progress",
  "awaiting_feedback",
  "final_payment_due",
  "delivered",
  "complete",
];
